import { AUTH_CONFIG } from '../config';

export class AuthLocalStorage {
	get authRegion() {
		return localStorage.getItem(AUTH_CONFIG.AUTH_REGION_KEY);
	}

	get authUserName() {
		return JSON.parse(localStorage.getItem(AUTH_CONFIG.AUTH_USERNAME_KEY));
	}

	setAuthStoreDetails = (region, username) => {
		localStorage.setItem(AUTH_CONFIG.AUTH_REGION_KEY, region);
		localStorage.setItem(AUTH_CONFIG.AUTH_USERNAME_KEY, JSON.stringify(username));
	}

	deleteAuthStoreDetails = () => {
		localStorage.clear();
	}
}